<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>{{"admin.countries.edit" | translate}} {{"admin.templates.template" | translate}}</h2>
  <mat-card-content>
    <form (submit)="sendEditionRequest()" [formGroup]="templateEditForm" autocomplete="off">
      <div class="form-container">
        <mat-form-field appearance="fill">
          <mat-label>{{"admin.dialogs.description" |translate}}</mat-label>
          <input [formControl]="descriptionControl" matInput type="text">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.templates.category" |translate}}</mat-label>
          <input matInput type="text" [value]="data.category.description" disabled>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.templates.subject" |translate}}</mat-label>
          <input [formControl]="subjectControl" matInput type="text">
        </mat-form-field>

        <ckeditor [editor]="editor" [formControl]="bodyControl"></ckeditor>

        <div class="edit-dialog-buttons-container">
          <button mat-raised-button (click)="closeDialog()" type="button" >
            <span>Close</span>
          </button>
          <button [disabled]="templateEditForm.invalid" mat-raised-button color="primary" type="submit">
            <span>Save</span>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-dialog-content>
